module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "institution"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "cover"
  }, [_c('h1', [_vm._v("金融机构")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h3', {
    on: {
      "click": function($event) {
        return _vm.topage('download', 'download-institution')
      }
    }
  }, [_vm._v("下载方案")])])]), _vm._v(" "), _c('header', [_c('div', {
    staticClass: "cover"
  }, [_c('section', [_c('span', {
    class: _vm.active === 'N+1' ? 'active' : '',
    on: {
      "click": function($event) {
        _vm.active = 'N+1'
      }
    }
  }, [_vm._v("N+1解决方案")]), _vm._v(" "), _c('span', {
    class: _vm.active === '1+N' ? 'active' : '',
    on: {
      "click": function($event) {
        _vm.active = '1+N'
      }
    }
  }, [_vm._v("1+N解决方案")])]), _vm._v(" "), (_vm.active === 'N+1') ? _c('footer', [_vm._m(1), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/imgs/portal/case/n+1@2x.png",
      "alt": "img"
    }
  })]) : (_vm.active === '1+N') ? _c('footer', [_vm._m(2), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/imgs/portal/case/1+n@2x.png",
      "alt": "img"
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "advantage"
  }, [_c('div', {
    staticClass: "cover"
  }, [_c('h1', [_vm._v("群星为银行带来的价值")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('h3', {
    on: {
      "click": function($event) {
        return _vm.topage('product')
      }
    }
  }, [_vm._v("了解供应链金融线上流程")])])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "cover"
  }, [_c('h1', [_vm._v("这里有海量优质企业资源")]), _vm._v(" "), _c('h2', [_vm._v("留下您的联系方式，我们的顾问将随时为您提供帮助")]), _vm._v(" "), _c('portal-form', {
    attrs: {
      "from": "case-institution"
    }
  }), _vm._v(" "), _vm._m(5)], 1)]), _vm._v(" "), _c('portal-footer', {
    attrs: {
      "page": "download-institution"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_vm._v("群星金融可通过供应链金融方案为核心企业和供应链上小微企业解决融资难融资贵的难题，"), _c('br'), _vm._v("不仅为当地企业整条供应链的健康发展服务，同时也带动了当地银行更好的开展多元化的供应链金融业务，"), _c('br'), _vm._v("增加小微企业开户数和放款量，真正实现多方共赢的局面。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contant"
  }, [_c('h2', [_vm._v("N+1解决方案")]), _vm._v(" "), _c('h3', [_vm._v("群星金融将供应商与核心企业的应收账款转让给金融机构，金融机构依据核心企业信用状况确定成本，决定是否受让应收账款，受让后给供应商提供融资／现金结算。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contant"
  }, [_c('h2', [_vm._v("1+N解决方案")]), _vm._v(" "), _c('h3', [_vm._v("群星通过对核心企业的应收账款进行量化分析和资产管理，引入金融机构来购买群星筛选的应收账款资产，不仅可以缓解经销商资金压力，也可提高核心企业销售规模，使供应链各方获得共赢。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', [_c('strong', [_vm._v("01")]), _vm._v(" "), _c('span', [_vm._v("引进大批量中小企业"), _c('br'), _vm._v("完成支小目标")])]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("02")]), _vm._v(" "), _c('span', [_vm._v("享受优质的"), _c('br'), _vm._v("大企业资源")])]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("03")]), _vm._v(" "), _c('span', [_vm._v("免费使用群星金融"), _c('br'), _vm._v("的线上平台")])]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("04")]), _vm._v(" "), _c('span', [_vm._v("改善利润结构"), _c('br'), _vm._v("增加中间性收入")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case"
  }, [_c('div', {
    staticClass: "cover"
  }, [_c('h1', [_vm._v("我们拥有的资源")]), _vm._v(" "), _c('div', {
    staticClass: "cover-line"
  }, [_c('img', {
    attrs: {
      "src": "/imgs/portal/case/ziyuan1@2x.png",
      "alt": "img"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/imgs/portal/case/ziyuan2@2x.png",
      "alt": "img"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "cover-line"
  }, [_c('img', {
    attrs: {
      "src": "/imgs/portal/case/ziyuan3@2x.png",
      "alt": "img"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/imgs/portal/case/ziyuan4@2x.png",
      "alt": "img"
    }
  })]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "anchor"
    }
  }, [_vm._v("……")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_vm._v("此类个人信息仅用于注册，合同和联系目的，绝不会与第三方共享。"), _c('br'), _vm._v("有关我们的更多信息以及我们如何保护您的个人信息，请参阅我们的"), _c('a', {
    attrs: {
      "href": "/pdf/tips.pdf",
      "download": "隐私声明"
    }
  }, [_vm._v("隐私声明")]), _vm._v("。")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-0c8e2036"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/portal/components/case/Institution.vue
// module id = 1260
// module chunks = 26